import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Eula from "./pages/Eula";

const Navigation = () => {
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="navbar-brand">
          GH Tracker
        </Link>
        <ul className="navbar-nav">
          <li>
            <Link to="/" className={location.pathname === "/" ? "active" : ""}>
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/privacy"
              className={location.pathname === "/privacy" ? "active" : ""}
            >
              Privacy
            </Link>
          </li>
          <li>
            <Link
              to="/eula"
              className={location.pathname === "/eula" ? "active" : ""}
            >
              EULA
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main className="main-content">
          <div className="container">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/eula" element={<Eula />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
